/*
 * @Author: your name
 * @Date: 2021-03-10 15:35:09
 * @LastEditTime: 2021-04-13 15:10:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\Master\main.js
 */
import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import global from '../../static/global'


Vue.config.productionTip = false
Vue.use(Antd)

Vue.prototype.$wx = {
  appid :global.appid ,
  url:  encodeURIComponent(global.loginPath+'/#/loading'),
  url2: encodeURIComponent(`${window.location.protocol}//${window.location.host}/#/system/perCenter`),
  url3: `${window.location.protocol}//${window.location.host}`
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/Master/main.js